import _defineProperty from "/data/var/lib/jenkins/workspace/AFM-Portal-Prod-CustomerEngage_AccountManagement_warfilebuild/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { getMainRangeChannel, getSecondaryRangeChannel, getSizeChannel, getVgPositionChannel, isXorY } from '../../../channel';
import { getBand, isFieldDef, isFieldOrDatumDef } from '../../../channeldef';
import { ScaleType } from '../../../scale';
import { contains } from '../../../util';
import { getMarkPropOrConfig } from '../../common';
import { getOffset } from './offset';
import * as ref from './valueref';
/**
 * Return encode for point (non-band) position channels.
 */

export function pointPosition(channel, model, _ref) {
  var defaultPos = _ref.defaultPos,
      vgChannel = _ref.vgChannel,
      isMidPoint = _ref.isMidPoint;
  var encoding = model.encoding,
      markDef = model.markDef,
      config = model.config,
      stack = model.stack;
  var channelDef = encoding[channel];
  var channel2Def = encoding[getSecondaryRangeChannel(channel)];
  var scaleName = model.scaleName(channel);
  var scale = model.getScaleComponent(channel);
  var offset = getOffset(channel, markDef); // Get default position or position from mark def

  var defaultRef = pointPositionDefaultRef({
    model: model,
    defaultPos: defaultPos,
    channel: channel,
    scaleName: scaleName,
    scale: scale
  });
  var valueRef = !channelDef && isXorY(channel) && (encoding.latitude || encoding.longitude) ? // use geopoint output if there are lat/long and there is no point position overriding lat/long.
  {
    field: model.getName(channel)
  } : positionRef({
    channel: channel,
    channelDef: channelDef,
    channel2Def: channel2Def,
    markDef: markDef,
    config: config,
    isMidPoint: isMidPoint,
    scaleName: scaleName,
    scale: scale,
    stack: stack,
    offset: offset,
    defaultRef: defaultRef
  });
  return valueRef ? _defineProperty({}, vgChannel || channel, valueRef) : undefined;
} // TODO: we need to find a way to refactor these so that scaleName is a part of scale
// but that's complicated. For now, this is a huge step moving forward.

/**
 * @return Vega ValueRef for normal x- or y-position without projection
 */

export function positionRef(params) {
  var channel = params.channel,
      channelDef = params.channelDef,
      isMidPoint = params.isMidPoint,
      scaleName = params.scaleName,
      stack = params.stack,
      offset = params.offset,
      markDef = params.markDef,
      config = params.config; // This isn't a part of midPoint because we use midPoint for non-position too

  if (isFieldOrDatumDef(channelDef) && stack && channel === stack.fieldChannel) {
    if (isFieldDef(channelDef)) {
      var band = getBand({
        channel: channel,
        fieldDef: channelDef,
        isMidPoint: isMidPoint,
        markDef: markDef,
        stack: stack,
        config: config
      });

      if (band !== undefined) {
        return ref.interpolatedSignalRef({
          scaleName: scaleName,
          fieldOrDatumDef: channelDef,
          startSuffix: 'start',
          band: band,
          offset: offset
        });
      }
    } // x or y use stack_end so that stacked line's point mark use stack_end too.


    return ref.valueRefForFieldOrDatumDef(channelDef, scaleName, {
      suffix: 'end'
    }, {
      offset: offset
    });
  }

  return ref.midPointRefWithPositionInvalidTest(params);
}
export function pointPositionDefaultRef(_ref3) {
  var model = _ref3.model,
      defaultPos = _ref3.defaultPos,
      channel = _ref3.channel,
      scaleName = _ref3.scaleName,
      scale = _ref3.scale;
  var markDef = model.markDef,
      config = model.config;
  return function () {
    var mainChannel = getMainRangeChannel(channel);
    var vgChannel = getVgPositionChannel(channel);
    var definedValueOrConfig = getMarkPropOrConfig(channel, markDef, config, {
      vgChannel: vgChannel
    });

    if (definedValueOrConfig !== undefined) {
      return ref.widthHeightValueOrSignalRef(channel, definedValueOrConfig);
    }

    switch (defaultPos) {
      case 'zeroOrMin':
      case 'zeroOrMax':
        if (scaleName) {
          var scaleType = scale.get('type');

          if (contains([ScaleType.LOG, ScaleType.TIME, ScaleType.UTC], scaleType)) {// Log scales cannot have zero.
            // Zero in time scale is arbitrary, and does not affect ratio.
            // (Time is an interval level of measurement, not ratio).
            // See https://en.wikipedia.org/wiki/Level_of_measurement for more info.
          } else {
            if (scale.domainDefinitelyIncludesZero()) {
              return {
                scale: scaleName,
                value: 0
              };
            }
          }
        }

        if (defaultPos === 'zeroOrMin') {
          return mainChannel === 'y' ? {
            field: {
              group: 'height'
            }
          } : {
            value: 0
          };
        } else {
          // zeroOrMax
          switch (mainChannel) {
            case 'radius':
              // max of radius is min(width, height) / 2
              return {
                signal: "min(".concat(model.width.signal, ",").concat(model.height.signal, ")/2")
              };

            case 'theta':
              return {
                signal: '2*PI'
              };

            case 'x':
              return {
                field: {
                  group: 'width'
                }
              };

            case 'y':
              return {
                value: 0
              };
          }
        }

        break;

      case 'mid':
        {
          var sizeRef = model[getSizeChannel(channel)];
          return Object.assign(Object.assign({}, sizeRef), {
            mult: 0.5
          });
        }
    } // defaultPos === null


    return undefined;
  };
}